import { b } from './chunk-26IU2X5T.mjs';
import { forwardRef } from 'react';
import o, { css } from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var f=css`
  font-size: var(--font-size-regular);
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-regular);
  line-height: var(--line-height-regular);
  color: var(--foreground-primary);
`,n=o.input`
  border: none;
  background-color: transparent;
  outline: none;
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-regular);
  line-height: var(--line-height-regular);
  color: var(--foreground-primary);
  width: 100%;
  padding: 0;
  ::placeholder {
    font-style: italic;
    color: var(--foreground-input-placeholder);
  }
`,t=o.span`
  ${f}
  padding-left: var(--spacing-small);
`,i=o.span`
  ${f}
  padding-right: var(--spacing-small);
`,k=css`
  color: var(--foreground-disabled);
  border: var(--border-width-x-small) solid var(--border-input-disabled);
  background: var(--background-input-disabled);
  outline: none;
  cursor: not-allowed;

  ${n},
  ${t},
  ${i} {
    background: var(--background-input-disabled);
    color: var(--foreground-disabled);
    cursor: not-allowed;
    ::placeholder {
      color: var(--foreground-disabled);
    }
  }

  &:hover {
    outline: none;
    border: var(--border-width-x-small) solid var(--border-input-disabled);
  }
`,A=css`
  border: var(--border-width-x-small) solid var(--border-input-error);

  &:hover {
    border: var(--border-width-x-small) solid var(--border-input-error);
  }

  &:focus-within {
    outline: var(--border-width-small) solid var(--border-input-error-outline);
    border: var(--border-width-x-small) solid var(--border-input-error);
  }
`,T=css`
  background-color: var(--background-input-default);
  border: var(--border-width-x-small) solid var(--border-input-read-only);
  outline: none;
`,v=o.button`
  background: none;
  border: none;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0;
  outline-color: var(--border-input-active);
`,d=o(b)`
  color: var(--foreground-secondary);
  padding-right: var(--spacing-small);
`,E=css`
  ${n},${t},${i} {
    font-size: var(--font-size-small);
  }

  ${d} {
    font-size: var(--icon-size-small);
  }
`,g=o.div`
  display: inline-flex;
  align-items: center;
  min-height: 42px;
  background-color: var(--background-input-default);
  border: var(--border-width-x-small) solid var(--border-input-default);
  border-radius: var(--border-radius-small);
  box-sizing: border-box;
  padding: var(--spacing-small) var(--spacing-regular);

  &:hover {
    outline: none;
    border: var(--border-width-x-small) solid var(--border-input-hover);
  }

  &:focus-within {
    outline: var(--border-width-small) solid var(--border-input-active-outline);
    border: var(--border-width-x-small) solid var(--border-input-active);
  }

  ${({$fluid:r})=>r&&"flex: 1;"}
  ${({$error:r})=>r&&A}
  ${({$readOnly:r})=>r&&T}
  ${({$disabled:r})=>r&&k}
  ${({$size:r})=>r==="small"&&E}
`,m=o.div`
  padding: 0 0 0 var(--spacing-regular);
  display: flex;
  align-items: center;
`;var R=forwardRef(({icon:r,action:s,onKeyDownAction:x,prefix:p,suffix:u,className:h,fluid:w=!1,size:$="regular",error:y=!1,disabled:l=!1,readOnly:c=!1,...I},z)=>jsxs(g,{$error:y,$disabled:l,$readOnly:c,$size:$,$fluid:w,className:h,children:[r&&jsx(d,{icon:r}),p&&jsx(i,{children:p}),jsx(n,{ref:z,disabled:l,readOnly:c,...I}),u&&jsx(t,{children:u}),s&&jsx(m,{children:jsx(v,{disabled:l,"aria-label":"Input action button",onKeyDown:x,type:"button",children:s})})]})),W=o(R)``;

export { W as a };
